import MaterialTableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Tooltip from "@mui/material/Tooltip";
import TableSortLabel from "@mui/material/TableSortLabel";
import PropTypes from "prop-types";

const ENTER_DELAY = 300;

const TableHead = (props) => {
  const { order, orderBy, classes } = props;

  const createSortHandler = (property) => (event) => {
    props.onRequestSort(event, property);
  };

  return (
    <MaterialTableHead>
      <TableRow>
        {props.rows.map(
          (row) => (
            <TableCell
              classes={{ root: classes.tableCell }}
              key={row.id}
              align={row.numeric ? "right" : "left"}
              padding={row.disablePadding ? "none" : "normal"}
              sortDirection={orderBy === row.id ? order : false}
            >
              <Tooltip
                title="Sort"
                placement={row.numeric ? "bottom-end" : "bottom-start"}
                enterDelay={ENTER_DELAY}
              >
                <TableSortLabel
                  active={orderBy === row.id}
                  direction={order}
                  onClick={createSortHandler(row.id)}
                >
                  {row.label}
                </TableSortLabel>
              </Tooltip>
            </TableCell>
          ),
          this,
        )}
      </TableRow>
    </MaterialTableHead>
  );
};

TableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  rows: PropTypes.array,
  classes: PropTypes.object,
};

export default TableHead;
